const urls = {
    live: "https://busapi.mavenconnect.tech/",
    stage: "https://stagebusapi.mavenconnect.tech/",
    other: "https://stagebusapi.mavenconnect.tech/"
};
const env = window.location.origin.includes('mavenconnect.tech') ? 'stage' : window.location.origin.includes('mavenconnect.biz') ? 'live' : 'other';
const baseURl = urls[env];
export const APIGenerateOTP = `${baseURl}api/CrewApp/APIGenerateOTP`;
export const GetDriverData = `${baseURl}api/CrewApp/GetDriverData?`;
export const APIValidateOTP = `${baseURl}api/CrewApp/APIValidateOTP`;
export const APIAssignedTrips = `${baseURl}api/CrewApp/APIAssignedTrips`;
export const BusScheduleListAll = `${baseURl}api/CrewApp/BusScheduleListAll`;
export const BusScheduleInsertUpdateCrew = `${baseURl}api/CrewApp/BusScheduleInsertUpdateCrew`;
export const TripSheetUrl = `${baseURl}api/CrewApp/TripSheet`;
export const TripDetails = `${baseURl}api/CrewApp/TripDetails`;
export const BusSchListAll = `${baseURl}api/BusSchedule/DriverConductorPickUpListAll`;
export const BusesActiveAll = `${baseURl}api/Common/BusesListActiveAll`;
export const GetBoardingReportData = `${baseURl}api/CrewApp/BoardingReportList`;
export const GetDriverDetailsCrew = `${baseURl}api/CrewApp/GetDriverDetailsCrew`;
export const ValidateBoarding = `${baseURl}api/CrewApp/APIPNRUpdate_AdditionalInfo`;
export const BookingStatusOfChart = `${baseURl}api/BookingChart/BookingStatusOfCharts_Tax_PD_Trip`;

